import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import { px2vw } from '@utils/px2vw';

export const Container = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  height: 70px;
  background-color: ${props => props.theme.colors.black};
  padding: 0 32px;
  font-size: 16px;
  position: fixed;
  z-index: 999999;
`;

export const Logo = styled(NavLink)`
  display: flex;
  align-items: center;
  color: #ffffff;
  cursor: pointer;
  text-decoration: none;
`;

export const Options = styled.div`
  position: absolute;
  bottom: 0;
`;

export const Option = styled(NavLink).attrs(props => ({
  activeStyle: {
    color: props.theme.colors.brand,
    fontWeight: '500',
  },
}))`
  display: block;
  color: ${props => props.theme.colors.grey700};
  text-decoration: none;
  cursor: pointer;
  padding: 10px
    ${({ theme: { openedSidebar } }) => (openedSidebar ? '25px' : '6px')};
  font-size: 1em;
  font-weight: 400;
  transition: padding 0.25s ease-in-out;
  &:hover {
    color: ${props => props.theme.colors.brand};
  }
`;

export const ContentOptions = styled.div`
  height: 85%;
  overflow-y: ${({ theme: { openedSidebar } }) =>
    openedSidebar ? 'auto' : 'unset'};
  overflow-x: ${({ theme: { openedSidebar } }) =>
    openedSidebar ? 'hidden' : 'unset'};
`;

export const ContentSubOptions = styled.div`
  transition: all 0.25s ease-in-out;
  position: ${({ theme: { openedSidebar } }) =>
    openedSidebar ? 'relative' : 'absolute'};
  top: ${({ theme: { openedSidebar } }) => (openedSidebar ? '0' : '15px')};
  left: ${({ theme: { openedSidebar } }) =>
    openedSidebar ? '0' : 'calc(100% + 10px)'};
  background: #fff;
  padding: 10px 20px;
  border-radius: 2px;
  box-shadow: ${({ theme: { openedSidebar } }) =>
    openedSidebar ? 'none' : '0 0 15px rgba(192, 192, 198, 0.35)'};
`;

export const ChildOption = styled.div`
  display: block;
  max-height: ${({ active, theme: { openedSidebar } }) =>
    active && openedSidebar ? '100%' : '44px'};
  font-weight: ${props => (props.active ? '800' : '500')};
  color: ${props => props.theme.colors.grey900};
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  padding: 10px 40px;
  padding-left: 20px;
  font-size: 1em;
  overflow: ${({ theme: { openedSidebar } }) =>
    openedSidebar ? 'hidden' : 'unset'};
  position: relative;
  background-color: ${props => props.theme.colors.white};
  transition: max-height 0.25s ease-in-out;
  &:before {
    content: '';
    display: inline-block;
    margin-right: 15px;
    vertical-align: middle;
    border-radius: 2px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${props => props.theme.colors.black};
    transition: all 0.25s ease-in-out;
    transform: rotateZ(${props => (props.active ? '0deg' : '180deg')});
    opacity: ${({ theme: { openedSidebar } }) => (openedSidebar ? '1' : '0')};
    visibility: ${({ childs, theme: { openedSidebar } }) =>
      !childs ? 'hidden' : openedSidebar ? 'visible' : 'hidden'};
    margin-left: ${({ theme: { openedSidebar } }) =>
      openedSidebar ? '0' : '-35px'};
  }
  > {
    span {
      vertical-align: middle;
      transition: all 0.25s ease-in-out;
      opacity: ${({ theme: { openedSidebar } }) => (openedSidebar ? '1' : '0')};
      visibility: ${({ theme: { openedSidebar } }) =>
        openedSidebar ? 'visible' : 'hidden'};
    }
    svg {
      vertical-align: middle;
      margin-right: 15px;
    }
  }
  > span ~ * {
    visibility: ${({ active, theme: { openedSidebar } }) =>
      active && openedSidebar ? 'visible' : 'hidden'};
    opacity: ${({ active, theme: { openedSidebar } }) =>
      active && openedSidebar ? '100' : '0'};
  }
  &:hover {
    font-weight: 800;
    > div {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const IconContainer = styled.div`
  width: ${px2vw(26)};
  height: ${px2vw(28)};
  margin-right: 24px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const HeaderTitle = styled.p`
  font-size: 1.5em;
  font-weight: 500;
  color: ${props => props.theme.colors.white};
  padding-right: 6rem;
`;

export const Line = styled.div`
  width: 1px;
  height: ${px2vw(41)};
  opacity: 0.51;
  border: solid 1px ${props => props.theme.colors.white};
  margin-right: 24px;
`;

export const Sidebar = styled.div`
  top: 70px;
  left: 0px;
  padding: 20px;
  position: absolute;
  background-color: #ffffff;
  height: calc(100vh - 70px);
  width: ${props => (props.open && '288px') || '84px'};
  transition: width 0.25s ease-in-out;
  box-shadow: 2px 0px 16px rgba(192, 192, 198, 0.25);
`;

export const CollapseNavbar = styled.div`
  top: 20px;
  z-index: 1;
  right: -15px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  border: 1px solid ${props => props.theme.colors.grey100};
  background-color: #ffffff;
  > svg {
    transition: all 0.25s ease-in-out;
    transform: rotateZ(
      ${({ theme: { openedSidebar } }) => (openedSidebar ? '0deg' : '180deg')}
    );
  }
`;
